<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Plants</li>
                </ol>
                <h4 class="main-title mb-0">Plants</h4>
            </div>
            <router-link to="/plants" type="submit" class="btn btn-primary" style="float: right;"><i class="ri-list-check fs-18 lh-1"></i> Plants</router-link>
        </div>
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="submitForm()">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                                <h6 class="card-title" v-if="status">Add Plant</h6>
                                <h6 class="card-title" v-else>Update Plant</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-4">
                                    <label class="form-label">Plant Code</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Plant Code" class="form-control" :class="{'is-invalid':errors.plant_code}" v-model="plant.plant_code" ref="plant_code" />
                                    <span v-if="errors.plant_code"><small class="text-danger">{{ errors.plant_code[0] }}</small></span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Cluster</label><span class="text-danger"> *</span>
                                    <!-- <select class="form-control" :class="{ 'is-invalid': errors.cluster_id }" v-model="plant.cluster_id" ref="cluster_id">
                                        <option value="">Select Cluster</option>
                                        <option v-for="cluster, key in clusters" :key="key" :value="cluster.cluster_id"> {{ cluster.cluster_name }}</option>
                                    </select> -->
                                    <search
                                        :class="{ 'is-invalid': errors.cluster_id }"
                                        :customClass="{ 'is-invalid': errors.cluster_id }"
                                        :initialize="plant.cluster_id"
                                        id="cluster_id"
                                        label="cluster_name"
                                        placeholder="Select Cluster"
                                        :data=" clusters" 
                                        @input=" cluster => plant.cluster_id = cluster"
                                    >
                                    </search>
                                    <span v-if="errors.cluster_id"><small class="text-danger">{{ errors.cluster_id[0] }}</small></span>
                                </div>
                                

                                <div class="col-md-4">
                                    <label class="form-label">Plant Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Plant Name" class="form-control" :class="{'is-invalid':errors.plant_name}" v-model="plant.plant_name" />
                                    <span v-if="errors.plant_name"><small class="text-danger">{{ errors.plant_name[0] }}</small></span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Latitude</label>
                                    <input type="text" placeholder="Latitude" class="form-control" :class="{'is-invalid':errors.latitude}" v-model="plant.latitude" />
                                    <span v-if="errors.latitude"><small class="text-danger">{{ errors.latitude[0] }}</small></span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Longitude</label>
                                    <input type="text" placeholder="Longitude" class="form-control" :class="{'is-invalid':errors.longitude}" v-model="plant.longitude" />
                                    <span v-if="errors.longitude"><small class="text-danger">{{ errors.longitude[0] }}</small></span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Radius</label>
                                    <input type="text" placeholder="Radius" class="form-control" :class="{'is-invalid':errors.radius}" v-model="plant.radius" />
                                    <span v-if="errors.radius"><small class="text-danger">{{ errors.radius[0] }}</small></span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button type="button" class="btn btn-danger me-2" @click="discard()"><i class="ri-close-line fs-18 lh-1"></i> Back</button>
                            <button v-if="status" type="submit" class="btn btn-primary"><i class="ri-save-line fs-18 lh-1"></i> Submit</button>
                            <button v-else type="submit" class="btn btn-primary"><i class="ri-save-line fs-18 lh-1"></i> Update</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import Search from "@/components/Search.vue";
    export default {
        components: {
            Search,
        },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "plant_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                plants: [],
                plant: {
                    plant_id: "",
                    cluster_id: "",
                    plant_code: "",
                    plant_name: "",
                    latitude: "",
                    longitude: "",
                    radius: "",
                },
                status: true,
                errors: [],
                plants: [],
                clusters: [],
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getClusters();
                if (to.name == "Plants.Create") {
                    vm.$refs.plant_code.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "getPlant", data: { plant_id: to.params.plant_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.plant = response.data.data;
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addPlant();
                } else {
                    vm.updatePlant();
                }
            },
            getClusters() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getClusters" })
                    .then((response) => {
                        loader.hide();
                        console.log("clures", response.data.data);
                        vm.clusters = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            addPlant() {
                let vm = this;
                let loader = this.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addPlant", data: vm.plant })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Plant Added successfully");
                        vm.$router.push("/plants");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updatePlant() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updatePlant", data: vm.plant })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Plant is successfully updated");
                        vm.$router.push("/plants");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            discard() {
                let vm = this;
                vm.plant.cluster_id = "";
                vm.plant.plant_code = "";
                vm.plant.plant_name = "";
                vm.plant.latitude = "";
                vm.plant.longitude = "";
                vm.plant.radius = "";
                vm.$refs.plant_code.focus();
                vm.errors = [];
                vm.status = true;
            },
        },
    };
</script>
